import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { loaderService } from 'services/loaderService';

export default function GlobalLoader() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Subscribe to loader state changes
    loaderService.subscribe((state) => {
      setOpen(state);
    });
  }, []);

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: 99999 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
